import React, {useEffect, useState} from "react";
import {IWishList} from "../../../interfaces";
import {getUserWishlists} from "../../../DAL/data-service";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";

/**
 * Create new wish list form
 * In use in AddToWishlist component
 */
const ItemAddedToList: React.FC<{addToWishList: IWishList|null ,showCreateNewlist:() => void ,hideAddToWishlistPopup: () => void}> = ({addToWishList,showCreateNewlist,hideAddToWishlistPopup}) => {

    const [wishlistsNumber, setWishlistsNumber] = useState<number>(10);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        //on component load, check if user has 10 wishlists
        //if user has 10 wishlist, hide "create new wish list" link
        (async () => {
            setIsLoading(true);
            sendGAEvent("Wish List","Add to Wish List");
            let currentWishlistsNumber = await getUserWishlists();
            setWishlistsNumber((currentWishlistsNumber.data.relatedData as []).length);
            setIsLoading(false);
        })();
    }, []);
    return (
        <div className="p-4 w-80">
            {!isLoading &&
                <div>
                    <div className="font-bold pb-2 text-center w-full">Item added to
                        {addToWishList !== null &&
                            <a href={'https://' + window.location.host + '/account/wishlist/' + addToWishList?.purl}
                               className="pl-1 text-blue-200 cursor-pointer">
                                {addToWishList?.listName}
                            </a>}
                    </div>
                    <div className="flex items-center justify-center w-full pt-6">
                        <button className="w-btn inline-block bg-blue-200 text-white font-normal w-auto px-9"
                                onClick={hideAddToWishlistPopup}>
                            <span>Close</span>
                        </button>
                    </div>
                    {/*show "create a new list" only if the user has less than 10 wishlists*/}
                    {wishlistsNumber !== 10 &&
                        <div className="flex items-center justify-center w-full pt-6">
                            <button type="button" className="text-blue-200 cursor-pointer" onClick={showCreateNewlist}>Create a new list</button>
                        </div>
                    }
                </div>
            }
        </div>
    )
};
export default ItemAddedToList;